import { render, staticRenderFns } from "./makes-item.vue?vue&type=template&id=1852e745"
import script from "./makes-item.vue?vue&type=script&lang=js"
export * from "./makes-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports